export default function isString(value) {
  return typeof value === 'string';
}
